import StrapiLatestNews from "@components/strapi/LatestNews"
import StrapiRelatedNews from "@components/strapi/RelatedNews"
import StrapiSlidingText from "@components/strapi/SlidingText"
import StrapiImageSlider from "@components/strapi/ImageSlider"
import StrapiNewsletterSignup from "@components/strapi/NewsletterSignup"
import StrapiContentHero from "@components/strapi/ContentHero"
import StrapiVideo from "@components/strapi/Video"
import StrapiUsps from "@components/strapi/Usps"
import StrapiEventMap from "@components/strapi/EventMap"
// eslint-disable-next-line import/no-cycle
import RepeatableComponent from "@components/strapi/RepeatableComponent"
import StrapiNewsContent from "@components/strapi/NewsContent"
import StrapiFaq from "@components/strapi/Faq"
import StrapiForm from "@components/strapi/Form"
import StrapiHero from "./Hero"

const components: any = {
    StrapiComponentSectionsHero: StrapiHero,
    StrapiComponentSectionsLatestNews: StrapiLatestNews,
    StrapiComponentSectionsRelatedNews: StrapiRelatedNews,
    StrapiComponentSectionsSlidingText: StrapiSlidingText,
    StrapiComponentSectionsImageSlider: StrapiImageSlider,
    StrapiComponentSectionsNewsletterSignup: StrapiNewsletterSignup,
    StrapiComponentSectionsContentHero: StrapiContentHero,
    StrapiComponentSectionsVideo: StrapiVideo,
    StrapiComponentSectionsUsps: StrapiUsps,
    StrapiComponentSectionsComponent: RepeatableComponent,
    StrapiComponentSectionsNewsContent: StrapiNewsContent,
    StrapiComponentSectionsFaq: StrapiFaq,
    StrapiComponentSectionsForm: StrapiForm,
    StrapiComponentSectionsEventMap: StrapiEventMap
}

export default components
